import axios from "axios";

window.addEventListener("DOMContentLoaded", () => {
	let search_zone = document.querySelector("#search-zone");
	let search_field = document.querySelector("#search-zone input[name='s']");
	let search_result = document.querySelector(".search-result .top");
	let profiles_result = document.querySelector(".search-result .profiles");
	let articles_result = document.querySelector(".search-result .articles");
	let loading = document.querySelector(".search-result .loading");
	let view_all = document.querySelector(".search-result .zone-bouton");
	let fire_button = document.querySelector(".search-result .ngo_button");
	let search_openers = document.querySelectorAll(".open-search");
	let mysearch = document.getElementById("mysearch");

	if (fire_button) {
		fire_button.addEventListener("click", () => {
			let term = search_field.value;
			window.location.href = `https://thedotgood.net/?s=${term}`;
		});
	}

	const get_results = (e) => {
		profiles_result.innerHTML = "";
		articles_result.innerHTML = "";
		loading.innerHTML = `<i class="fa-thin fa-spinner-third fa-spin"></i> We are searching for you. Please wait...`;
		if (search_field.value.length >= 3) {
			loading.classList.add("visible");
			let form_data = new FormData();
			form_data.append("action", "load_search_results");
			form_data.append("query", search_field.value);
			axios.post(ajaxurl, form_data)
				.then((data) => {
					loading.classList.remove("visible");
					if (data.data.profiles.length + data.data.articles.length === 0) {
						loading.innerHTML = "No results found for your query";
					} else {
						let top = `<span class="profile current">Profile (${data.data.profiles.length})</span>
						<span class="article">Article (${data.data.articles.length})</span>
						`;
						search_result.innerHTML = top;
						let first_profiles = data.data.profiles;
						first_profiles.forEach((el) => {
							let classes = "sgo";
							if (el.locations) {
								el.locations.forEach((item) => {
									classes += ` ${item.slug}`;
								});
							} else {
								classes += ` world`;
							}
							let element = `<a class="${classes}" href="${el.permalink}" title="${el.name} on thedotgood.">
								<img class="featured" title="${el.name}" alt="${el.name} on the dot good" loading="lazy" src="${el.featured}" />
								<div class="bottom">
									<h2>${el.name}</h2>
									<h3>${el.slogan || ""}</h3>
									<div class="more"><i class="far fa-angle-right"></i></div>
								</div>
							</a>
							`;
							profiles_result.innerHTML += element;
						});
						let first_articles = data.data.articles;
						first_articles.forEach((el) => {
							let classes = "sgo";
							if (el.locations) {
								el.locations.forEach((item) => {
									classes += ` ${item.slug}`;
								});
							} else {
								classes += ` world`;
							}
							let element = `<div class="news">
									<img class="featured" loading="lazy" src="${el.featured}" />
									<div class="topish">
										<div class="ong">${el.contributor}</div>
										<h2><a href="${el.permalink}" title="${el.name}">${el.resume}</a></h2>
									</div>
									<div class="bottom">
										<div class="author">
											By <span> ${el.author_firstname} ${el.author_name}</span>
											<em>${el.author_description}</em>
										</div>
										<div class="date">${el.date}</div>
										<a href="${el.permalink}" title="${el.name}" class="more">
											<i class="far fa-angle-right"></i>
										</a>
									</div>
								</div>`;
							articles_result.innerHTML += element;
						});
						let switcher = document.querySelectorAll(".search-result .top span");
						if (switcher) {
							switcher.forEach((el) => {
								el.addEventListener("click", switchPanels);
							});
						}
					}
				})
				.catch((err) => {
					console.log(err);
				});
		}
	};

	const switchPanels = (e) => {
		if (e.currentTarget.classList.contains("profile")) {
			profiles_result.classList.remove("hidden");
			articles_result.classList.add("hidden");
			document.querySelector(".search-result .top span.current").classList.remove("current");
			e.currentTarget.classList.add("current");
		} else {
			profiles_result.classList.add("hidden");
			articles_result.classList.remove("hidden");
			document.querySelector(".search-result .top span.current").classList.remove("current");
			e.currentTarget.classList.add("current");
		}
	};

	mysearch.addEventListener("submit", (e) => {
		e.preventDefault();
		get_results();
	});

	if (search_zone && search_openers) {
		search_openers.forEach((el) => {
			el.addEventListener("click", () => {
				search_zone.classList.toggle("visible");
			});
		});
	}
});
